import React, { Component } from "react";
import {
	Row,
	Col,
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Card,
	CardBody,
	CardFooter,
	FormGroup,
	Spinner,
	Label,
} from "reactstrap";
import { connect } from "react-redux";
import SimpleBar from "simplebar-react";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";
import moment from "moment";
import "./CompareQuotation.scss";
import Swal from "sweetalert2";
import Select from "react-select";

import {
	getCompareQuotationData,
	PurchaseOrderData,
	GeneratePurchaseOrder,
	po_model_close,
	PurchaseOrderVendData,
	InputChangeValue,
	POSelecteChangeValue,
	ResetSubLocation,
} from "../../../store/SRCompareQuotation/actions";
import {
	getMini2SubLocations,
	setSub2LocationParams,
	clearMini2SubLocations,
} from "../../../store/Mini/actions";
import { Message } from "@material-ui/icons";

const taxTypeOptions = [
	{ value: 1, label: "Asset" },
	{ value: 2, label: "General" },
	{ value: 3, label: "Stores" },
];
class GeneratePurchaseOrderModel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			item_details: [],
		};
		// this.toggleTab = this.toggleTab.bind(this);
		this.PurchaseOrderthis = this.PurchaseOrder.bind(this);
		this.ChangeHandeler = this.ChangeHandeler.bind(this);
	}
	componentDidMount() {
		this.PurchaseOrder();
		this.PurchaseOrderRowData(0);
		this.GetMIniSubLocations(this.props);
		this.props.ResetSubLocation();
	}
	PurchaseOrder() {
		var len = this.props.CQbodyData.length;
		var vendorsItems = this.props.Quotations.map((q) => {
			var total = 0;
			var vendItems = [];

			for (let i = 0; i < len; i++) {
				const row = this.props.CQbodyData[i];
				const vendId = "Vendor" + q.vendor.id;
				if (Object.hasOwnProperty.call(row, vendId)) {
					var cell = row[vendId];
					console.log("cell", cell);
					total += parseInt(cell.updateGrossValue);
					if (row[vendId].Quotationcheck) {
						vendItems.push({
							product_id: row["ItemName"].product_id,
							qty: cell.ApprovedQuantity,
							unit_id: cell.unit.id,
							tax_id: cell.tax_id,
							taxtype: cell.taxtype,
							taxamount: cell.taxamount,
							qitem_id: cell.qitem_id,
							baseprice: cell.baseprice,
							discount: cell.discount,
							discountpercent: cell.discountpercent,
							price: cell.Price,
							gross: cell.updateGrossValue,
							make: cell.make,
							description: cell.description,
							cqitem_id: cell.id,
						});
					}
				}
			}
			return {
				poitems: vendItems,
				deliverydate: q.deliverydate,
				requestforquotation_id: this.props.RFQrowdata.id,
				quotation_id: q.id,
				terms: q.terms,
				total: total,
				vendorName: q.vendor.name,
				vendor_id: q.vendor.id,
				loading: false,
				requestStatus: 1, //1: Pending 2: Submited 3:Retrey
			};
		});
		vendorsItems = vendorsItems.filter((po) => {
			return po.poitems.length !== 0;
		});
		this.props.PurchaseOrderData(vendorsItems);
	}
	PurchaseOrderRowData(index) {
		if (index === this.props.SR_PO_index) {
			Swal.fire({
				title: "Are you sure Change Vendor ?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Yes",
			}).then((result) => {
				if (result.isConfirmed) {
					this.addForm && this.addForm.reset();
					this.props.PurchaseOrderVendData(index);
				}
			});
		} else {
			this.addForm && this.addForm.reset();
			this.props.PurchaseOrderVendData(index);
		}
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.PORowData.userLocation_id !==
				this.props.PORowData.userLocation_id ||
			prevProps.PORowData.costCenterId !==
				this.props.PORowData.costCenterId
		) {
			this.GetMIniSubLocations(this.props);
			this.props.ResetSubLocation();
		}
	}

	GetMIniSubLocations(props) {
		const { PORowData, getMini2SubLocations, sublocationParamas2 } = props;

		if (PORowData.userLocation_id !== undefined) {
			getMini2SubLocations({
				location: PORowData.userLocation_id,
				cost_center_type: PORowData.costCenterId,
				page: 1,
				page_size: 10,
			});
		}
	}
	// ResetSubLocation(){
	//   this.setState({
	//     subLocationLabel: '',
	//     subLocationId: ''
	//   });
	// }
	ChangeHandeler(e) {
		this.props.InputChangeValue({
			key: e.target.name,
			value: e.target.value,
		});
	}
	handleValidSubmit() {
		// if (
		// 	this.props.PORowData.purchaseValue == null ||
		// 	this.props.PORowData.purchaseValue === ""
		// ) {
		// 	Swal.fire({
		// 		icon: "error",
		// 		text: "Select Purchase Type",
		// 	});
		// 	return;
		// }
		var vendData = this.props.POData[this.props.SR_PO_index];
		console.log("VendData", vendData);
		var pOData = {
			woitems: vendData.poitems,
			location_id: this.props.PORowData.userLocation_id,
			// advance: this.props.PORowData.advanceValue,
			work_type: this.props.PORowData.purchaseValue,
			advancepercentage: this.props.PORowData.advancepercentage,
			// cost_center_type: this.props.PORowData.costCenterId,
			sublocation_id: this.props.PORowData.subLocationId,
			deliverydate: vendData.deliverydate,
			servicerequestforquotation_id: vendData.requestforquotation_id,
			servicequotation_id: vendData.quotation_id,
			terms: vendData.terms,
			total: vendData.total,
			vendor_id: vendData.vendor_id,
			delivery: this.props.PORowData.delivery,
			transport: this.props.PORowData.transport,
			// transport_by:this.props.PORowData.transport_by_value,
			payment: this.props.PORowData.payment,
			pnf: this.props.PORowData.pnf,
			gstdetails: this.props.PORowData.gstdetails,
			remarks: this.props.PORowData.remarks,
			externalremarks: this.props.PORowData.externalremarks,
			servicecomparequotation_id: this.props.CQRowData.id,
		};

		this.props.GeneratePurchaseOrder(pOData);
	}
	// PurchaseOrderAllData() {
	//   this.props.POData.forEach((data) => {
	//     if (data.requestStatus !== 2) {
	//       this.PurchaseOrderRowData(data);
	//     }
	//   });
	// }
	closeModel() {
		Swal.fire({
			title: "Are you sure?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes",
		}).then((result) => {
			if (result.isConfirmed) {
				this.addForm && this.addForm.reset();
				this.props.po_model_close();
				this.props.getCompareQuotationData(this.props.CQRowData.id);
			}
		});
	}

	render() {
		return (
			<React.Fragment>
				<Modal
					isOpen={this.props.SR_PO_Model}
					// toggle={this.props.po_model_close()}
					backdrop="static"
					centered
					size="xl">
					<ModalHeader
						toggle={() => {
							this.closeModel();
						}}>
						Service Order Summary
					</ModalHeader>
					<ModalBody className="pt-0">
						<Row className="justify-content-center">
							<Col md={12}>
								<Row>
									<Col md={4}>
										<Card className="pt-1">
											<CardBody className="p-0">
												<SimpleBar
													style={{ height: "75vh" }}>
													<div
														id="Items-menu"
														className="pl-2 pr-2">
														<ul
															className="metismenu list-unstyled"
															id="Items-menu">
															{this.props.POData
																.length ===
															0 ? (
																<>
																	{this.props
																		.loading ? (
																		<div className="text-center">
																			<Spinner color="primary" />
																		</div>
																	) : (
																		<div className="text-center">
																			<span className="font-size-18 text-danger">
																				Service
																				Order
																				Data
																				not
																				available
																			</span>
																		</div>
																	)}
																</>
															) : (
																<>
																	{this.props.POData.map(
																		(
																			data,
																			i
																		) => (
																			<>
																				<li>
																					<Link
																						to="#"
																						onClick={() => {
																							this.PurchaseOrderRowData(
																								i
																							);
																						}}
																						className={
																							i ===
																							this
																								.props
																								.SR_PO_index
																								? "waves-effect Item-active"
																								: "waves-effect"
																						}
																						id={
																							data.vendor_id
																						}>
																						<span>
																							<span
																								style={{
																									color: "#74788d",
																								}}>
																								Vendor
																								Name:
																							</span>{" "}
																							<b>
																								{
																									data.vendorName
																								}
																							</b>
																						</span>
																						<br />
																						<span>
																							<span
																								style={{
																									color: "#74788d",
																								}}>
																								Items:
																							</span>{" "}
																							<b>
																								{
																									data
																										.poitems
																										.length
																								}{" "}
																								Items
																							</b>
																						</span>
																						<br />

																						{/* {data.requestStatus !== 2 ? (
                                            <span className="font-size-14 text-primary ">
                                              Pending
                                            </span>
                                          ) : (
                                            <Badge color="secondary">
                                              Generated
                                            </Badge>
                                          )} */}
																						{/* text-danger  text-primary*/}
																					</Link>
																				</li>
																			</>
																		)
																	)}
																</>
															)}
														</ul>
													</div>
												</SimpleBar>
											</CardBody>
										</Card>
									</Col>
									<Col md={8}>
										{this.props.SR_PO_index != null &&
										this.props.POData.length !== 0 ? (
											<>
												<div className="pt-4">
													<Card className="pt-1">
														<CardBody className="p-0">
															<ul className="list-style-podata p-0 ml-4  ">
																<Row>
																	<Col md={6}>
																		<li className="clearfix">
																			<span className="ttl">
																				vendor
																				Name:
																			</span>
																			<span className="dtl">
																				{
																					this
																						.props
																						.POData[
																						this
																							.props
																							.SR_PO_index
																					]
																						.vendorName
																				}
																			</span>
																		</li>
																	</Col>
																	<Col md={6}>
																		<li className="clearfix">
																			<span className="ttl">
																				Delivery
																				Date:
																			</span>
																			<span className="dtl">
																				{moment(
																					this
																						.props
																						.POData[
																						this
																							.props
																							.SR_PO_index
																					]
																						.deliverydate
																				).format(
																					"DD-MM-YYYY"
																				)}
																			</span>
																		</li>
																	</Col>
																	<Col md={6}>
																		<li className="clearfix">
																			<span className="ttl">
																				Total
																				Items:
																			</span>
																			<span className="dtl">
																				{
																					this
																						.props
																						.POData[
																						this
																							.props
																							.SR_PO_index
																					]
																						.poitems
																						.length
																				}{" "}
																				Items
																			</span>
																		</li>
																	</Col>
																	<Col md={6}>
																		<li className="clearfix">
																			<span className="ttl">
																				Total
																				Gross:
																			</span>
																			<span className="dtl">
																				&#8377;{" "}
																				{
																					this
																						.props
																						.POData[
																						this
																							.props
																							.SR_PO_index
																					]
																						.total
																				}
																			</span>
																		</li>
																	</Col>
																</Row>
															</ul>
														</CardBody>
													</Card>
													<Card className="p-1 ">
														<AvForm
															className="form-horizontal"
															onValidSubmit={() =>
																this.handleValidSubmit()
															}
															ref={(c) =>
																(this.addForm =
																	c)
															}>
															<CardBody className="p-2 ">
																{this.props
																	.POData[
																	this.props
																		.SR_PO_index
																]
																	.requestStatus !==
																2 ? (
																	<>
																		<Row className="justify-content-center">
																			<Col
																				md={
																					6
																				}>
																				<FormGroup>
																					<Label
																						htmlFor="Delivery"
																						className="col-form-label ">
																						Delivery
																						:
																					</Label>

																					<AvField
																						name="delivery"
																						type="text"
																						value={
																							this
																								.props
																								.PORowData
																								.delivery ==
																							null
																								? ""
																								: this
																										.props
																										.PORowData
																										.delivery
																						}
																						onChange={
																							this
																								.ChangeHandeler
																						}
																						className="form-control"
																						id="Delivery"
																						placeholder="Enter Delivery Details"
																						errormessage=" Please provide a valid text"
																						validate={{
																							required:
																								{
																									value: true,
																								},
																						}}
																					/>
																				</FormGroup>
																			</Col>
																			<Col
																				md={
																					6
																				}>
																				<FormGroup>
																					<Label
																						htmlFor="Transport"
																						className="col-form-label ">
																						Transport
																						:
																					</Label>

																					<AvField
																						name="transport"
																						type="text"
																						value={
																							this
																								.props
																								.PORowData
																								.transport ==
																							null
																								? ""
																								: this
																										.props
																										.PORowData
																										.transport
																						}
																						onChange={
																							this
																								.ChangeHandeler
																						}
																						className="form-control"
																						id="Transport"
																						placeholder="Enter Transport Details"
																						errormessage=" Please provide a valid text"
																						validate={{
																							required:
																								{
																									value: true,
																								},
																						}}
																					/>
																				</FormGroup>
																			</Col>
																			{/* <Col
																				md={
																					6
																				}>
																				<FormGroup>
																					<Label
																						htmlFor="transport_by"
																						className="col-form-label ">
																						Transport Type
																						:
																					</Label>
																					<Select
																						id="transport_by"
																						name="transport_by"
																						classNamePrefix="select2-selection"
																						options={[
																							{
																								label: "Buyer",
																								value: 1,
																							},
																							{
																								label: "Seller",
																								value: 2,
																							},
																						].map(
																							(
																								item
																							) => ({
																								label: item.label,
																								value: item.value,
																							})
																						)}
																						value={{
																							label:
																								this
																									.props
																									.PORowData
																									?.transport_by_label ==
																								null
																									? "Select Transport Type"
																									: this
																											.props
																											.PORowData
																											?.transport_by_label,
																							value: this
																								.props
																								.PORowData
																								?.transport_by_value,
																						}}
																						onChange={(
																							e
																						) => {
																							console.log(
																								e
																							);
																							if (
																								e.value ==
																								"false"
																							) {
																								this.ChangeHandeler(
																									{
																										target: {
																											name: "advancepercentage",
																											value: 0,
																										},
																									}
																								);
																							}
																							this.props.POSelecteChangeValue(
																								{
																									key: "transport_by_label",
																									label: e.label,
																									key2: "transport_by_value",
																									value: e.value,
																								}
																							);
																						}}
																					/>
																				</FormGroup>
																				</Col> */}
																			<Col
																				md={
																					6
																				}>
																				<FormGroup>
																					<Label
																						htmlFor="Payment"
																						className="col-form-label ">
																						Payment
																						:
																					</Label>

																					<AvField
																						name="payment"
																						type="text"
																						value={
																							this
																								.props
																								.PORowData
																								.payment ==
																							null
																								? ""
																								: this
																										.props
																										.PORowData
																										.payment
																						}
																						onChange={
																							this
																								.ChangeHandeler
																						}
																						className="form-control"
																						id="Payment"
																						placeholder="Enter Payment Details"
																						errormessage=" Please provide a valid text"
																						validate={{
																							required:
																								{
																									value: true,
																								},
																						}}
																					/>
																				</FormGroup>
																			</Col>
																			<Col
																				md={
																					6
																				}>
																				<FormGroup>
																					<Label
																						htmlFor="PnF"
																						className="col-form-label ">
																						P&F
																						:
																					</Label>

																					<AvField
																						name="pnf"
																						type="text"
																						value={
																							this
																								.props
																								.PORowData
																								.pnf ==
																							null
																								? ""
																								: this
																										.props
																										.PORowData
																										.pnf
																						}
																						onChange={
																							this
																								.ChangeHandeler
																						}
																						className="form-control"
																						id="PnF"
																						placeholder="Enter P & F Details"
																						errormessage=" Please provide a valid text"
																						validate={{
																							required:
																								{
																									value: true,
																								},
																						}}
																					/>
																				</FormGroup>
																			</Col>
																			<Col
																				md={
																					6
																				}>
																				<FormGroup>
																					<Label
																						htmlFor="PnF"
																						className="col-form-label ">
																						GST
																						Type
																						:
																					</Label>

																					<AvField
																						name="gstdetails"
																						type="text"
																						value={
																							this
																								.props
																								.PORowData
																								.gstdetails ==
																							null
																								? ""
																								: this
																										.props
																										.PORowData
																										.gstdetails
																						}
																						onChange={
																							this
																								.ChangeHandeler
																						}
																						className="form-control"
																						id="PnF"
																						placeholder="Enter GST Details"
																						errormessage=" Please provide a valid text"
																						validate={{
																							required:
																								{
																									value: true,
																								},
																						}}
																					/>
																				</FormGroup>
																			</Col>
																			<Col
																				md={
																					6
																				}>
																				<FormGroup>
																					<Label
																						htmlFor="PnF"
																						className="col-form-label ">
																						Location
																						:
																					</Label>
																					<Select
																						id="location_id_select"
																						name="location_id_select"
																						classNamePrefix="select2-selection"
																						options={this.props.userLocation.map(
																							(
																								item
																							) => ({
																								label: item.name,
																								value: item.id,
																							})
																						)}
																						value={{
																							label:
																								this
																									.props
																									.PORowData
																									?.userLocationLabel ==
																								null
																									? "Select Location"
																									: this
																											.props
																											.PORowData
																											?.userLocationLabel,
																							value: this
																								.props
																								.PORowData
																								?.userLocation_id,
																						}}
																						onChange={(
																							e
																						) => {
																							this.props.POSelecteChangeValue(
																								{
																									key: "userLocationLabel",
																									label: e.label,
																									key2: "userLocation_id",
																									value: e.value,
																								}
																							);
																						}}
																					/>
																				</FormGroup>
																			</Col>
																			{/* <Col
																				md={
																					6
																				}>
																				<FormGroup>
																					<Label
																						htmlFor="advance"
																						className="col-form-label ">
																						Advance
																						:
																					</Label>
																					<Select
																						id="advance"
																						name="advance"
																						classNamePrefix="select2-selection"
																						options={[
																							{
																								label: "Yes",
																								value: true,
																								key: "1",
																							},
																							{
																								label: "No",
																								value: false,
																								key: "2",
																							},
																						].map(
																							(
																								item
																							) => ({
																								label: item.label,
																								value: item.value,
																							})
																						)}
																						value={{
																							label:
																								this
																									.props
																									.PORowData
																									?.advanceLabel ==
																								null
																									? "Select Advance"
																									: this
																											.props
																											.PORowData
																											?.advanceLabel,
																							value: this
																								.props
																								.PORowData
																								?.advanceValue,
																						}}
																						onChange={(
																							e
																						) => {
																							console.log(
																								e
																							);
																							if (
																								e.value ==
																								"false"
																							) {
																								this.ChangeHandeler(
																									{
																										target: {
																											name: "advancepercentage",
																											value: 0,
																										},
																									}
																								);
																							}
																							this.props.POSelecteChangeValue(
																								{
																									key: "advanceLabel",
																									label: e.label,
																									key2: "advanceValue",
																									value: e.value,
																								}
																							);
																						}}
																					/>
																				</FormGroup>
																			</Col>
																			<Col
																				md={
																					6
																				}>
																				<FormGroup>
																					<Label
																						htmlFor="purchase_type"
																						className="col-form-label ">
																						Purchase
																						Type
																						:
																					</Label>
																					<Select
																						id="purchase_type"
																						name="purchase_type"
																						classNamePrefix="select2-selection"
																						options={
																							taxTypeOptions
																						}
																						value={{
																							label:
																								this
																									.props
																									.PORowData
																									?.purchaseLabel ==
																								null
																									? "Select  Purchase Type"
																									: this
																											.props
																											.PORowData
																											?.purchaseLabel,
																							value: this
																								.props
																								.PORowData
																								?.purchaseValue,
																						}}
																						onChange={(
																							e
																						) => {
																							console.log(
																								e
																							);
																							// if (e.value == "false") {
																							//   this.ChangeHandeler({
																							//     target: {
																							//       name: "advancepercentage",
																							//       value: 0,
																							//     },
																							//   });
																							// }
																							this.props.POSelecteChangeValue(
																								{
																									key: "purchaseLabel",
																									label: e.label,
																									key2: "purchaseValue",
																									value: e.value,
																								}
																							);
																						}}
																					/>
																				</FormGroup>
																			</Col> */}

																			{/* {this
																				.props
																				.PORowData
																				?.userLocation_id && (
																				<Col
																					md={
																						6
																					}>
																					<FormGroup>
																						<Label
																							htmlFor="costCenter"
																							className="col-form-label ">
																							Cost
																							Center
																							Type
																							:
																						</Label>
																						<Select
																							id="costCenter"
																							name="costCenter"
																							classNamePrefix="select2-selection"
																							options={[
																								{
																									label: "Company",
																									value: 1,
																									key: "1",
																								},
																								{
																									label: "personal",
																									value: 2,
																									key: "2",
																								},
																							].map(
																								(
																									item
																								) => ({
																									label: item.label,
																									value: item.value,
																								})
																							)}
																							value={{
																								label:
																									this
																										.props
																										.PORowData
																										?.costCenterType ==
																									null
																										? "Select Cost Center Type"
																										: this
																												.props
																												.PORowData
																												?.costCenterType,
																								value: this
																									.props
																									.PORowData
																									?.costCenterId,
																							}}
																							onChange={(
																								e
																							) => {
																								console.log(
																									e
																								);
																								if (
																									e.value ==
																									"false"
																								) {
																									this.ChangeHandeler(
																										{
																											target: {
																												name: "advancepercentage",
																												value: 0,
																											},
																										}
																									);
																								}
																								this.props.POSelecteChangeValue(
																									{
																										key: "costCenterType",
																										label: e.label,
																										key2: "costCenterId",
																										value: e.value,
																									}
																								);
																							}}
																						/>
																					</FormGroup>
																				</Col>
																			)} */}

																			{this
																				.props
																				.PORowData
																				.costCenterType !==
																			undefined ? (
																				<Col
																					md={
																						6
																					}>
																					<FormGroup>
																						<Label
																							htmlFor="sublocation"
																							className="col-form-label ">
																							Sub
																							Location
																							:
																						</Label>
																						<Select
																							id="sublocation"
																							name="sublocation"
																							classNamePrefix="select2-selection"
																							onInputChange={(
																								value,
																								{
																									action,
																								}
																							) => {
																								if (
																									action ===
																									"input-change"
																								) {
																									this.props.setSub2LocationParams(
																										{
																											...this
																												.props
																												.sublocationParamas2,
																											page: 1,
																											page_size: 10,
																											search: value,
																										}
																									);
																									this.props.getMini2SubLocations(
																										{
																											location:
																												this
																													.props
																													.PORowData
																													.userLocation_id,
																											cost_center_type:
																												this
																													.props
																													.PORowData
																													.costCenterId,
																											page: 1,
																											page_size: 10,
																											search: value,
																										}
																									);
																								}
																							}}
																							options={this.props?.sublocationslist2?.results?.map(
																								(
																									item
																								) => ({
																									label: item.name,
																									value: item.id,
																								})
																							)}
																							onMenuClose={() => {
																								this.props.clearMini2SubLocations(
																									{}
																								);
																								this.props.setSub2LocationParams(
																									{
																										...this
																											.props
																											.sublocationParamas2,
																										page: 1,
																										page_size: 10,
																									}
																								);
																								this.props.getMini2SubLocations(
																									{
																										location:
																											this
																												.props
																												.PORowData
																												.userLocation_id,
																										cost_center_type:
																											this
																												.props
																												.PORowData
																												.costCenterId,
																										page: 1,
																										page_size: 10,
																									}
																								);
																							}}
																							onMenuScrollToBottom={() => {
																								if (
																									this
																										.props
																										.sublocationParamas2
																										.page <
																									this
																										.props
																										.sublocationParamas2
																										.no_of_pages
																								) {
																									this.props.setSub2LocationParams(
																										{
																											...this
																												.props
																												.sublocationParamas2,
																											page:
																												this
																													.props
																													.sublocationParamas2
																													.page +
																												1,
																											page_size: 10,
																										}
																									);
																									this.props.getMini2SubLocations(
																										{
																											location:
																												this
																													.props
																													.PORowData
																													.userLocation_id,
																											cost_center_type:
																												this
																													.props
																													.PORowData
																													.costCenterId,
																											page:
																												this
																													.props
																													.sublocationParamas2
																													.page +
																												1,
																											page_size: 10,
																										}
																									);
																								}
																							}}
																							value={{
																								label:
																									this
																										.props
																										.PORowData
																										?.subLocationLabel ==
																									null
																										? "Select Cost Center Type"
																										: this
																												.props
																												.PORowData
																												?.subLocationLabel,
																								value: this
																									.props
																									.PORowData
																									?.subLocationId,
																							}}
																							onChange={(
																								e
																							) => {
																								console.log(
																									e
																								);
																								if (
																									e.value ==
																									""
																								) {
																									this.ChangeHandeler(
																										{
																											target: {
																												name: "advancepercentage",
																												value: 0,
																											},
																										}
																									);
																								}
																								this.props.POSelecteChangeValue(
																									{
																										key: "subLocationLabel",
																										label: e.label,
																										key2: "subLocationId",
																										value: e.value,
																									}
																								);
																							}}
																						/>
																					</FormGroup>
																				</Col>
																			) : (
																				<Col
																					md={
																						6
																					}></Col>
																			)}

																			{this
																				.props
																				.PORowData
																				?.advanceValue ? (
																				<Col
																					md={
																						6
																					}>
																					<FormGroup>
																						<Label
																							htmlFor="advancepercentage"
																							className="col-form-label ">
																							Advance
																							Percentage
																							(%):
																						</Label>
																						<AvForm>
																							<AvField
																								name="advancepercentage"
																								type="number"
																								value={
																									this
																										.props
																										.PORowData
																										.advancepercentage ==
																									null
																										? ""
																										: this
																												.props
																												.PORowData
																												.advancepercentage
																								}
																								onChange={
																									this
																										.ChangeHandeler
																								}
																								className="form-control"
																								id="advancepercentage"
																								placeholder="Enter Advance Percentage"
																								errormessage=" Please provide a valid text"
																								validate={{
																									required:
																										{
																											value: true,
																										},
																									max: {
																										value: 100,
																										errorMessage:
																											"Cannot exceed 100%",
																									},
																								}}
																								max="100"
																							/>
																						</AvForm>
																					</FormGroup>
																				</Col>
																			) : (
																				<Col
																					md={
																						6
																					}></Col>
																			)}

																			<Col
																				md={
																					12
																				}>
																				<FormGroup className="mb-0">
																					<Label
																						htmlFor="Remarks"
																						className="col-form-label ">
																						Internal
																						Remarks:
																					</Label>
																					<AvField
																						name="remarks"
																						id="Remarks"
																						type="textarea"
																						className="form-control"
																						placeholder="Enter Internal Remarks"
																						value={
																							this
																								.props
																								.PORowData
																								.remarks ==
																							null
																								? ""
																								: this
																										.props
																										.PORowData
																										.remarks
																						}
																						rows="7"
																						validate={{
																							required:
																								{
																									value: true,
																								},
																						}}
																						onChange={
																							this
																								.ChangeHandeler
																						}
																					/>
																				</FormGroup>
																			</Col>
																			<Col
																				md={
																					12
																				}>
																				<FormGroup className="mb-0">
																					<Label
																						htmlFor="externalremarks"
																						className="col-form-label ">
																						External
																						Remarks:
																					</Label>
																					<AvField
																						name="externalremarks"
																						id="externalremarks"
																						type="textarea"
																						className="form-control"
																						placeholder="Enter External Remarks"
																						value={
																							this
																								.props
																								.PORowData
																								.externalremarks ==
																							null
																								? ""
																								: this
																										.props
																										.PORowData
																										.externalremarks
																						}
																						rows="7"
																						validate={{
																							required:
																								{
																									value: true,
																								},
																						}}
																						onChange={
																							this
																								.ChangeHandeler
																						}
																					/>
																				</FormGroup>
																			</Col>
																		</Row>
																	</>
																) : (
																	<>
																		<div className="text-center">
																			<span className="font-size-18 text-success ">
																				Generated
																			</span>
																		</div>
																	</>
																)}
															</CardBody>
															<CardFooter className="bg-transparent p-1">
																<div className="float-right">
																	<Button
																		type="reset"
																		color="light"
																		className="waves-effect waves-light mr-2"
																		onClick={() =>
																			this.closeModel()
																		}>
																		Cancel
																	</Button>

																	{this.props
																		.POData[
																		this
																			.props
																			.SR_PO_index
																	]
																		.loading ===
																		true && (
																		<Button
																			type="sudmit"
																			color="primary"
																			className="waves-effect waves-light mr-2"
																			disabled={
																				true
																			}>
																			Loading
																		</Button>
																	)}
																	{this.props
																		.POData[
																		this
																			.props
																			.SR_PO_index
																	]
																		.requestStatus ===
																		1 &&
																		this
																			.props
																			.POData[
																			this
																				.props
																				.SR_PO_index
																		]
																			.loading ===
																			false && (
																			<Button
																				type="sudmit"
																				color="primary"
																				className="waves-effect waves-light mr-2"
																				// onClick={() => {
																				//   this.PurchaseOrderRowData(this.props.poVendData);
																				// }}
																			>
																				Generate
																				PO
																			</Button>
																		)}
																	{this.props
																		.POData[
																		this
																			.props
																			.SR_PO_index
																	]
																		.requestStatus ===
																		3 &&
																		this
																			.props
																			.POData[
																			this
																				.props
																				.SR_PO_index
																		]
																			.loading ===
																			false && (
																			<Button
																				type="sudmit"
																				color="primary"
																				className="waves-effect waves-light mr-2"
																				// onClick={() => {
																				//   this.PurchaseOrderRowData(data);
																				// }}
																			>
																				Retry
																			</Button>
																		)}
																	{this.props
																		.POData[
																		this
																			.props
																			.SR_PO_index
																	]
																		.requestStatus ===
																		2 &&
																		this
																			.props
																			.POData[
																			this
																				.props
																				.SR_PO_index
																		]
																			.loading ===
																			false &&
																		this
																			.props
																			.POData
																			.length >
																			this
																				.props
																				.SR_PO_index +
																				1 && (
																			<Button
																				type="button"
																				color="success"
																				className="waves-effect waves-light mr-2"
																				onClick={() => {
																					this.PurchaseOrderRowData(
																						this
																							.props
																							.POData
																							.length <=
																							this
																								.props
																								.SR_PO_index +
																								1
																							? this
																									.props
																									.POData
																									.length
																							: this
																									.props
																									.SR_PO_index +
																									1
																					);
																				}}>
																				Next
																			</Button>
																		)}
																</div>
															</CardFooter>
														</AvForm>
													</Card>
												</div>
											</>
										) : (
											<div className="pt-4">
												<Card className="pt-1">
													<CardBody className="p-2 ">
														<div className="text-center">
															<span className="font-size-18 text-danger">
																Data not
																available
															</span>
														</div>
													</CardBody>
												</Card>
											</div>
										)}
									</Col>
								</Row>
							</Col>
						</Row>
					</ModalBody>
				</Modal>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { userLocation, sublocationslist2, sublocationParamas2 } = state.Mini;
	const {
		SR_PO_Model,
		SR_PO_ID,
		SR_PO_index,
		PORowData,
		CQRowData,
		CQbodyData,
		Quotations,
		POData,
		loading,
		RFQrowdata,
	} = state.SRCompareQuotation;
	return {
		SR_PO_Model,
		SR_PO_ID,
		SR_PO_index,
		PORowData,
		CQRowData,
		userLocation,
		CQbodyData,
		Quotations,
		POData,
		loading,
		RFQrowdata,
		sublocationslist2,
		sublocationParamas2,
	};
};

export default connect(mapStatetoProps, {
	getCompareQuotationData,
	PurchaseOrderData,
	GeneratePurchaseOrder,
	po_model_close,
	PurchaseOrderVendData,
	InputChangeValue,
	POSelecteChangeValue,
	getMini2SubLocations,
	clearMini2SubLocations,
	setSub2LocationParams,
	ResetSubLocation,
})(GeneratePurchaseOrderModel);
